import { render } from "./PetStore.vue?vue&type=template&id=d728e9ba&scoped=true"
import script from "./PetStore.vue?vue&type=script&lang=js"
export * from "./PetStore.vue?vue&type=script&lang=js"

import "./PetStore.vue?vue&type=style&index=0&id=d728e9ba&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d728e9ba"]])

export default __exports__